// Archivo de configuración para tokens secretos
// IMPORTANTE: Cambia estos tokens por unos que solo tú conozcas

export const SECRET_TOKENS = {
  // Token para auto-pago de gimnasios
  AUTO_PAYMENT_GYM: "gym_auto_payment_2024_secret_token_xyz123",
  
  // Puedes agregar más tokens secretos aquí
  // ADMIN_ACCESS: "tu_token_admin_secreto",
  // MAINTENANCE_MODE: "tu_token_mantenimiento",
};

// Función para verificar si un token es válido
export const isValidToken = (tokenType, providedToken) => {
  return SECRET_TOKENS[tokenType] === providedToken;
};

// Función para obtener un token específico
export const getSecretToken = (tokenType) => {
  return SECRET_TOKENS[tokenType];
}; 